var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-sg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M27.682 0h708.66v708.66H27.682z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-20) scale(.72249)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1063v708.66H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0000",
    d: "M0 0h1063v354.33H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.165 59.399c-49.08 11.253-85.548 47.594-95.86 97.004-14.008 67.128 29.719 132.855 96.976 146.885-67.952 19.373-138.17-19.688-157.365-87.013-19.193-67.323 19.868-137.541 87.193-156.736 23.634-6.74 45.392-6.783 69.056-.14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M202.056 162.445l-18.946-13.81 23.44-.202 7.281-22.303 7.428 22.248 23.458.037-18.854 13.939 7.226 22.32-19.093-13.627-19.001 13.756zm25.93 76.86l-18.946-13.81 23.44-.202 7.281-22.303 7.428 22.248 23.458.037-18.854 13.939 7.226 22.32-19.093-13.627-19.001 13.756zm86.26-.57l-18.946-13.81 23.44-.202 7.281-22.303 7.428 22.248 23.458.037-18.854 13.939 7.226 22.32-19.093-13.627-19.001 13.756zm25.72-76.23l-18.946-13.81 23.44-.202 7.281-22.303 7.428 22.248 23.458.037-18.854 13.939 7.226 22.32-19.093-13.627-19.001 13.756zm-68.29-50.58l-18.946-13.81 23.44-.202 7.281-22.303 7.428 22.248 23.458.037-18.854 13.939 7.226 22.32-19.093-13.627-19.001 13.756z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.15dcabd5b20a20acf15f6ed3c7215a79.svg";
export { ForwardRef as ReactComponent };